import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import useNotify from "../../unit/useNotify";
import NoResults from "../../unit/NoResults";
import formatDate from "../../unit/formatDate";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const standStatus = ($status: any): string => {
  $status = $status.toLowerCase();
  if (
    $status == "success" ||
    $status == "succeed" ||
    $status == "processed" ||
    $status == "created"
  ) {
    return "Success";
  } else if ($status == "fail" || $status == "failed") {
    return "Failed";
  }
  return $status;
};

const getPaymentSourceStatus = (item: any, appPayment: any): string => {
  const isDisabled =
    item?.sStatus == "Disabled" || item?.accountStatus == "Disabled";

  if (item?.sUsingSource == "REPAYMENT") {
    return appPayment && appPayment?.sRepaymentPayment == "SMART_ACH"
      ? isDisabled
        ? "Disabled"
        : item?.sStatus
      : "Offline";
  }

  if (item?.sUsingSource == "DISBURSEMENT") {
    return appPayment && appPayment?.sDisbursementPayment == "SMART_ACH"
      ? isDisabled
        ? "Disabled"
        : item?.sStatus
      : "Offline";
  }

  if (item?.sUsingSource == "DEPOSIT") {
    return appPayment && appPayment?.sRepaymentPayment == "SMART_ACH"
      ? isDisabled
        ? "Disabled"
        : item?.sStatus
      : "Offline";
  }

  if (item?.sSource == "INSTITUTION") {
    return "Offline";
  }

  return isDisabled ? "Disabled" : item?.sStatus;
};

const LoanPaymentSourceData = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/accountList",
    {
      id: appId,
    }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;

  const appPayment = data.appPayment;
  const paymentSourceData = data.accountData;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          stickyHeader
          id="table-loan-summary-payment-source-log-list"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Account ID
              </TableCell>
              <TableCell className="hm-table-header">Payments Made</TableCell>
              <TableCell className="hm-table-header">Source</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Institution Name
              </TableCell>
              <TableCell className="hm-table-header">Account Type</TableCell>
              <TableCell className="hm-table-header">Routing Number</TableCell>
              <TableCell className="hm-table-header">Account Number</TableCell>
              <TableCell className="hm-table-header">Status</TableCell>
              {/* created date and disabled date  */}
              <TableCell className="hm-table-header">Created Date</TableCell>
              <TableCell className="hm-table-header">Disabled Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentSourceData == undefined ||
            paymentSourceData.length == 0 ||
            paymentSourceData == null ? (
              <TableRow>
                <TableCell colSpan={8} className="no-results">
                  <NoResults />
                </TableCell>
              </TableRow>
            ) : (
              paymentSourceData.map((item: any) => (
                <TableRow key={item.id}>
                  <TableCell>{item?.id}</TableCell>
                  {/* <TableCell>{iAccountId}</TableCell> */}
                  <TableCell>
                    {item?.sUsingSource == "REPAYMENT"
                      ? "Repayment from"
                      : item?.sUsingSource == "DISBURSEMENT"
                      ? "Disburse to"
                      : item?.sUsingSource}
                  </TableCell>
                  <TableCell>{item?.sSource}</TableCell>
                  <TableCell>{item?.sInstitutionName}</TableCell>
                  <TableCell>{item?.sAccountType}</TableCell>
                  <TableCell>{item?.sRoutingNumber}</TableCell>
                  <TableCell>{item?.sAccountNumber}</TableCell>
                  <TableCell>
                    {getPaymentSourceStatus(item, appPayment)}
                  </TableCell>
                  <TableCell>{formatDate(item?.created_at)}</TableCell>
                  <TableCell>
                    {getPaymentSourceStatus(item, appPayment) == "Disabled" &&
                      formatDate(item?.updated_at)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanPaymentSourceData;
